<div class="wrapper">
    <app-menu></app-menu>
    <div class="main-content">
        
        <router-outlet></router-outlet>
        
    </div>
</div>

<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-scale-multiple" [fullScreen] = "true"><p style="color: white" > Chargement... </p></ngx-spinner>

